import { useEffect } from "react";

export const usePageTitle = (title) => {
  useEffect(() => {
    document.title = title ? `${title} · Lamka Online` : "Lamka Online — Beauty & Fashion";
  }, [title]);
};
